import React from "react";
import t from "./translate";

function WarningIcon() {
  return (
    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600">
      <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.72 3h16.92a2 2 0 0 0 1.72-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      </svg>
    </div>
  );
}

export default function ConfirmationModal({
  open,
  title = t("shared.confirmation_modal.title"),
  message = t("shared.confirmation_modal.message"),
  confirmLabel = t("shared.confirmation_modal.confirm"),
  confirmingLabel = t("shared.confirmation_modal.confirming"),
  cancelLabel = t("shared.confirmation_modal.cancel"),
  onConfirm,
  onCancel,
  confirming = false,
  confirmDisabled = false,
  children = null
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/55 px-4 py-6 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-[28px] bg-white p-7 text-center shadow-[0_30px_80px_rgba(15,23,42,0.22)]">
        <div className="mx-auto flex justify-center">
          <WarningIcon />
        </div>

        <h3 className="mt-5 text-2xl font-semibold text-slate-950">{title}</h3>
        <div className="mx-auto mt-3 max-w-sm text-sm leading-7 text-slate-500">{message}</div>
        {children ? <div className="mt-5 text-left">{children}</div> : null}

        <div className="mt-7 flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex w-full items-center justify-center rounded-2xl border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirming || confirmDisabled}
            className="inline-flex w-full items-center justify-center rounded-2xl bg-red-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {confirming ? confirmingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
